export interface AppscriptsUserDetails {
  registeredAt: Date | null;
  balance: number;
  lastActive: Date | null;
  fullName?: string | null;
}

export const EMPTY_APPSCRIPTS_USER_DETAILS: AppscriptsUserDetails = {
  registeredAt: null,
  balance: 0,
  lastActive: null,
};
